import * as React from 'react'
import {ReactNode} from 'react'
import {withErrorSubscribe} from './hoc/withErrorSubscribe'
import {ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import FormErrorMessage from './FormErrorMessage'
import {withHint} from './hoc/withHintButton'
import {FlexStaticContent, LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import { FormControlLabel, Checkbox, FormGroup, Box } from '@mui/material';
import { CheckboxProps } from '@mui/material/Checkbox';
import { FormGroupProps } from '@mui/material/FormGroup';

export interface PPCheckboxProp {
    label: string
    checked: boolean
    checkboxProps?: CheckboxProps
}

interface Props {
    data: PPCheckboxProp[]
    onChangeChecked?: (label: string, checked: boolean) => void
}

interface State {
    selectedLabels: string[]
}

const BoxWithHint = withHint(Box)

class PPCheckboxGroup
    extends React.Component<FormGroupProps & Props & ErrorHandlingFormProps, State> {

    static displayName: string = 'PPCheckboxGroup'

    constructor(props: Readonly<FormGroupProps & Props & ErrorHandlingFormProps>) {
        super(props)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.state = {
            selectedLabels: [],
        }
    }

    handleCheckboxChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        this.setState({...this.state, [name]: checked}, () => {
            if (this.props.onChangeChecked) {
                this.props.onChangeChecked(name, checked)
            }
        })
    }

    render(): ReactNode {
        const {
            onChangeChecked,
            data, messages, hint, eventKeys, eventEmitter,
            hasError,
            clearErrorMessage,
            ...rest
        } = this.props

        return <FlexStaticContent>
            <LeftColumnFlexContainer>
                <BoxWithHint hint={hint}>
                    <FormGroup {...rest} >
                        {
                            data.map((item, i) =>
                                <Box ml={i !== 0 ? '15px' : undefined} key={i}>
                                    <FormControlLabel
                                        label={item.label}
                                        control={(
                                            <Checkbox
                                                color="primary"
                                                checked={item.checked}
                                                {...item.checkboxProps}
                                                onChange={this.handleCheckboxChange(item.label)}
                                            />
                                        )}
                                    />
                                </Box>,
                            )
                        }
                    </FormGroup>
                </BoxWithHint>
                {
                    messages &&
                    <FormErrorMessage
                        messages={messages.map((pair) => {
                            return {
                                message: pair.message,
                                params: this.state.selectedLabels,
                            }
                        })}
                    />
                }
            </LeftColumnFlexContainer>
        </FlexStaticContent>
    }
}

export default withErrorSubscribe(PPCheckboxGroup)

